export function getDomain() {
  return window.location.host;
}
